import React from "react";
import Icon from "./icons";
import "./termsCopy.css";

// "What happens to your answers": one card for both copies of the terms (the homepage's
// TermsConditionsModal and the chat's terms step in Chatbot.js), so they never drift apart.
// It must not promise confidentiality: the guidance office reads the answers and may reach
// out, and staff may draft notes with AI tools. Plain words; a 16-year-old reads it alone.
export const ANSWERS_COPY = {
  en: {
    title: "What happens to your answers",
    points: [
      "Your answers are saved.",
      "Your school's guidance office can see them.",
      "If something worries them, they may reach out to you.",
      "You can stop anytime.",
    ],
    note:
      "Your guidance office may use AI tools to help write their notes, and a counselor checks them. Questions about your data? Ask your guidance office. The Data Privacy Act (RA 10173) applies.",
  },
  fil: {
    title: "Ano ang nangyayari sa mga sagot mo",
    points: [
      "Naka-save ang mga sagot mo.",
      "Nakikita ito ng guidance office ng school mo.",
      "Kung may ikinababahala sila, maaari ka nilang kausapin.",
      "Puwede kang tumigil anumang oras.",
    ],
    note:
      "Maaaring gumamit ang guidance office ng AI tools para tumulong sa pagsulat ng notes nila, at sinusuri ito ng isang counselor. May tanong tungkol sa data mo? Magtanong sa guidance office mo. Saklaw ito ng Data Privacy Act (RA 10173).",
  },
};

export const answersCopy = (language) => ANSWERS_COPY[language === "fil" ? "fil" : "en"];

export const AnswersCard = ({ language = "en" }) => {
  const copy = answersCopy(language);
  return (
    <section className="tc-answers" aria-labelledby="tc-answers-title">
      <h3 className="tc-answers-title" id="tc-answers-title">
        <span className="tc-answers-icon" aria-hidden="true">
          <Icon name="shield-check" size={20} />
        </span>
        {copy.title}
      </h3>
      <ul className="tc-answers-list">
        {copy.points.map((point) => (
          <li key={point}>
            <Icon name="check" size={16} aria-hidden="true" />
            <span>{point}</span>
          </li>
        ))}
      </ul>
      <p className="tc-answers-note">{copy.note}</p>
    </section>
  );
};

export default AnswersCard;
